var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGift = function SvgGift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 0c14.912 0 27 12.088 27 27S41.912 54 27 54 0 41.912 0 27 12.088 0 27 0Z",
    fill: "#F2F4FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.334 20.125h-5.028c.228-.405.36-.874.36-1.375 0-1.516-1.195-2.75-2.666-2.75-1.536 0-3.13 1.136-4 2.595C26.13 17.136 24.536 16 23 16c-1.47 0-2.667 1.234-2.667 2.75 0 .501.133.97.361 1.375h-5.027a.677.677 0 0 0-.667.688v4.125c0 .38.298.687.667.687h.666v11.688c0 .38.299.687.667.687h20a.677.677 0 0 0 .667-.688V25.626h.666a.677.677 0 0 0 .667-.688v-4.125a.677.677 0 0 0-.667-.687ZM31 17.375c.735 0 1.334.617 1.334 1.375s-.599 1.375-1.334 1.375h-3.225c.407-1.382 1.917-2.75 3.225-2.75Zm-9.333 1.375c0-.758.598-1.375 1.333-1.375 1.308 0 2.818 1.368 3.225 2.75H23c-.735 0-1.333-.617-1.333-1.375Zm-5.334 2.75h10v2.75h-10V21.5Zm1.334 4.125h8.666v11h-8.666v-11Zm18.666 11h-8.666v-11h8.666v11Zm1.334-12.375h-10V21.5h10v2.75Z",
    fill: "#5C7AFF"
  })));
};

export default SvgGift;